module.exports = __webpack_public_path__ + "img/icon_arrow-down.4e9b4c44.svg";